import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { COLORS } from 'muiTheme/colors';

export function SectionGhost({ title }: { title?: string }) {
  if (!title) {
    return null;
  }

  return (
    <Box
      data-testid="section-ghost"
      key={title}
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      paddingLeft="1rem"
      height="2.5rem"
    >
      <Typography
        variant="body2"
        sx={{
          color: COLORS.appFog500,
          WebkitFontSmoothing: 'initial',
          fontFeatureSettings: "'liga' off, 'clig' off",
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
